/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Flüssig`
};

const en_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Fluid`
};

const es_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Fluida`
};

const fr_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Fluide`
};

const it_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Scorrevole`
};

const nl_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Vlot`
};

const pt_map_tools__traffic_info_fluid__label = /** @type {(inputs: {}) => string} */ () => {
	return `Fluida`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_tools__traffic_info_fluid__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_tools__traffic_info_fluid__label", locale)
	if (locale === "de") return de_map_tools__traffic_info_fluid__label(inputs)
	if (locale === "en") return en_map_tools__traffic_info_fluid__label(inputs)
	if (locale === "es") return es_map_tools__traffic_info_fluid__label(inputs)
	if (locale === "fr") return fr_map_tools__traffic_info_fluid__label(inputs)
	if (locale === "it") return it_map_tools__traffic_info_fluid__label(inputs)
	if (locale === "nl") return nl_map_tools__traffic_info_fluid__label(inputs)
	return pt_map_tools__traffic_info_fluid__label(inputs)
};